import React, { useState } from "react";
import { Container, TextField, Button, Alert, Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";
import Footer from "../../Footer";
import { useAuth } from "../../utils/AuthContext";

const BackgroundContainer = styled(Box)({
    display: "flex",
    height: "100vh",
    width: "100%",
    overflow: "hidden",
    backgroundImage: "url('/images/freepik__login-background-im-stil-von-microsoft-hintergrnde__49399.jpeg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
});

const FormWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "33%",
    marginLeft: "33%",
});

const FormContainer = styled(Container)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    padding: "2rem",
    borderRadius: "12px",
    width: "100%",
});

const backend = process.env.REACT_APP_BACKEND_URL || "";

export default function Login() {
    const { login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [busy, setBusy] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password) {
            setErrorMessage("Bitte E-Mail und Passwort eingeben.");
            return;
        }
        setErrorMessage("");
        setBusy(true);
        try {
            const res = await fetch(`${backend}/api/login`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });

            // kann bei 4xx/5xx ebenfalls JSON sein
            let data = {};
            try { data = await res.json(); } catch (_) {}

            if (res.ok) {
                // Flask gibt { message, user: { username } } zurück
                const user = data?.user || { username };
                // optional: hier zusätzlich Token aus data.token übernehmen, falls vorhanden
                login(user); // -> schaltet App auf MainApp um
            } else {
                setErrorMessage(data?.error || "Anmeldung fehlgeschlagen");
            }
        } catch (err) {
            console.error("Login error:", err);
            setErrorMessage("Fehler bei der Verbindung zum Server");
        } finally {
            setBusy(false);
        }
    };

    return (
        <BackgroundContainer>
            <FormWrapper>
                <FormContainer component="form" onSubmit={handleSubmit}>
                    <Box
                        component="img"
                        src={`${process.env.PUBLIC_URL}/images/krystin_ai_transparent.png`}
                        alt="Leadgen"
                        sx={{ width: 250, height: "auto", borderRadius: "12px", boxShadow: 0, mb: 1 }}
                    />

                    <TextField
                        label="username"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={busy}
                        autoFocus
                    />
                    <TextField
                        label="Passwort"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={busy}
                    />

                    <Button
                        variant="contained"
                        type="submit"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={busy}
                    >
                        {busy ? <CircularProgress size={22} sx={{ my: "2px" }} /> : "Sign in"}
                    </Button>

                    {errorMessage && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {errorMessage}
                        </Alert>
                    )}
                </FormContainer>
            </FormWrapper>
            <Footer />
        </BackgroundContainer>
    );
}
